








































import demo1 from './demo1.vue';
import demo2 from './demo2.vue';
import Anchor from '@/packages/d-anchor';
import Vue from 'vue';
import Component from 'vue-class-component';
import DCascader from '@/packages/d-cascader';
import title from '../../packages/d-cascader/demo/README.md';
import props from '../../packages/d-cascader/demo/props.md';

Vue.use(Anchor);
Vue.use(DCascader);
@Component({
  name: 'ComponentDemo',
  components: {
    demo1, demo2
  }
})
export default class ComponentDemo extends Vue {
  public title = title;
  public props = props;

  public getContainer() {
    return document.getElementById('app-content');
  }
}
